module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"session_expiry_warning":{"text":"Uw sessie zal aflopen in {countdown} seconden.","cta":"Verleng sessie"}},"en-BE":{"session_expiry_warning":{"text":"Your session will expire in {countdown} seconds.","cta":"Continue session"}},"fr-BE":{"session_expiry_warning":{"text":"Votre session va expirer dans {countdown} secondes.","cta":"Continuer la session"}}}')
  delete Component.options._Ctor
}
